// TODO: Check these mandrill templates by name and decide if were going to update them
e360.constant('experiencesConstants', {
   "TYPE_EMAIL": 5,
   "TYPE_QRCODE": 6,
   "TYPE_APP": 4,
   "TYPE_PASSBOOK": 3,
   "TYPE_RSVP_SITE": 1,
   "TYPE_MEDIA_PAGE": 2,
   "TYPE_SMS": 7,
   "TYPE_WEB_REG": 8,
   "TYPE_JOIN_VIRTUAL": 9,
   "EXPERIENCES": {
      passbook: [
         {
            index: 0,
            id: 3,
            label: 'Passbook',
            slug: 'passbook'
         }
      ],
      rsvp: [
         {
            index: 0,
            id: 1,
            label: 'RSVP Site',
            parent_label: 'RSVP',
            icon: 'fa-sitemap',
            slug: 'rsvp'
         }
      ],
      thank_you: [
         {
            index: 14,
            id: 5,
            label: 'Thank You Email',
            mandrill_template: 'e360-env-thank-you-email',
            email_name: 'PostEventThankyou',
            icon: 'fa-envelope-o',
            slug: 'thank-you-email'
         }
      ],
      sorry: [
         {
            index: 15,
            id: 5,
            label: 'Sorry Email',
            mandrill_template: 'e360-env-sorry-email',
            email_name: 'PostEventNotAttend',
            icon: 'fa-envelope-o',
            slug: 'sorry-email'
         }
      ],
      registration: [
         {
            index: 16,
            id: 5,
            label: 'Registration Email',
            mandrill_template: 'e360-env-registration-email',
            email_name: 'Registration',
            icon: 'fa-envelope-o',
            slug: 'registration-email'
         }
      ],
      qrcode: [
         {
            index: 13,
            id: 6,
            label: 'QR Page',
            icon: 'fa-file-text-o',
            slug: 'qr-page'
         }
      ],
      media_sms: [
         {
            index: 0,
            id: 7,
            label: 'Media SMS',
            type: 1,
            icon: 'icon-iphone',
            slug: 'media-sms'
         }
      ],
      web_reg: [
         {
            index: 0,
            id: 8,
            label: 'Mobile Self-Registration',
            icon: 'fa-sitemap',
            slug: 'web-reg'
         }
      ],
      join_virtual: [
         {
            index: 0,
            id: 9,
            label: 'Join Virtual Page',
            icon: 'fa-sitemap',
            slug: 'join-virtual'
         }
      ],
      // mandrill_template is used for listing the templates to admin as well as setting the default template when an
      // email is created
      // -env- is replaced when adding a template and removed when listing and sending to the listTemplates API
      rsvp_emails: [
         {
            index: 1,
            id: 5,
            label: 'Confirmation Email',
            parent_label: 'RSVP',
            mandrill_template: 'e360-env-confirmation-email',
            email_name: 'RsvpConfirm',
            icon: 'fa-envelope-o',
            slug: 'confirmation-email'
         },
         {
            index: 2,
            id: 5,
            label: 'Invite Email',
            parent_label: 'RSVP',
            mandrill_template: 'e360-env-invite-email',
            email_name: 'RsvpInvite',
            icon: 'fa-envelope-o',
            slug: 'invite-email'
         },
         {
            index: 3,
            id: 5,
            label: 'Friend Invite Email',
            parent_label: 'RSVP',
            mandrill_template: 'e360-env-friend-invite-email',
            email_name: 'RsvpTellFriend',
            icon: 'fa-envelope-o',
            slug: 'friend-invite-email'
         },
         {
            index: 4,
            id: 5,
            label: 'Guest Invite Email',
            parent_label: 'RSVP',
            mandrill_template: 'e360-env-guest-invite-email',
            email_name: 'RsvpGuestInvite',
            icon: 'fa-envelope-o',
            slug: 'guest-invite-email'
         },
         {
            index: 5,
            id: 5,
            label: 'Reminder Email',
            parent_label: 'RSVP',
            mandrill_template: 'e360-env-reminder-email',
            email_name: 'RsvpReminder',
            icon: 'fa-envelope-o',
            slug: 'reminder-email'
         },
         {
            index: 6,
            id: 5,
            label: 'Join Link Email',
            parent_label: 'RSVP',
            mandrill_template: 'e360-env-webinar-email',
            email_name: 'WebinarReminder',
            icon: 'fa-envelope-o',
            slug: 'webinar-email'
         }
      ],
      app: [
         {
            index: 6,
            id: 4,
            device: 1,
            label: 'iPhone App',
            parent_label: 'App Workflow',
            icon: 'icon-iphone',
            slug: 'app-phone',
            defaultImages: {}
         },
         {
            index: 7,
            id: 4,
            device: 2,
            label: 'iPad App',
            parent_label: 'App Workflow',
            icon: 'icon-ipad',
            slug: 'app-tablet',
            defaultImages: {}
         }
      ],
      app_page: [
         {
            index: 8,
            id: 2,
            label: 'Media Page',
            parent_label: 'App Photo',
            icon: 'fa-file-text-o',
            slug: 'media-page'
         },
         {
            index: 9,
            id: 5,
            label: 'Media Email',
            parent_label: 'App Photo',
            mandrill_template: 'e360-env-media-email',
            email_name: 'Media',
            icon: 'fa-envelope-o',
            slug: 'media-email'
         }
      ]
   }
});
